import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import crossIcon from '../assets/images/crossIcon.svg';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'    
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2, 4, 3),
    position: 'relative', 
  },
  closeButton: {
    padding: 0,
    margin: 0,
    display: 'inline-block',
    border: 0,
    lineHeight: 'normal',
    fontSize: 0,
    background: 'transparent',
    position: 'absolute',
    right: 4,
    top: 4,
    cursor: 'pointer',
    width: 30,
    height: 30,
  }
}));

interface LabelProps{
    heading: string;
    content: string;
    open?: boolean;
    onClose?: () => void;
    showCloseButton?: boolean;
}

export const WarningModal: React.FC<LabelProps> = (props: LabelProps) =>{
    const{
       heading, content, open: controlledOpen, onClose: controlledOnClose, showCloseButton
    } = props;


  const classes = useStyles();
  const [internalOpen, setInternalOpen] = React.useState(true);

  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const handleClose = () => {
    if (controlledOnClose) {
      controlledOnClose();
    } else {
      setInternalOpen(false);
    }
  };

  return (
    <div>
      
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <b><h4 id="transition-modal-title">{heading}</h4></b>
            <p id="transition-modal-description">{content}</p>
            {
              showCloseButton && (
                <button onClick={handleClose} className={classes.closeButton}><img src={crossIcon} alt="cross" /></button>
              )
            }
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default WarningModal